<div class="bp-modal mod-lg">
  <!-- Header -->
  <bp-modal-header [title]="headerTitleKey | translate">
    <a right (click)="onClickHeaderButton()" (keydown.enter)="onClickHeaderButton()" [tabIndex]="0">
      <strong>{{ headerButtonKey | translate }}</strong>
    </a>
  </bp-modal-header>
  <!-- Body -->
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 min-h-400">
      <div class="center-block max-w-468 text-center">
        <!-- Title -->
        <h2 class="mb-15 mt-90">{{ "password_validation_enter_password" | translate }}</h2>
        <!-- Description -->
        <p class="mb-20 font-size-17">{{ descriptionKey | translate }}</p>
        <form
          class="form-group"
					[ngClass]="{
						'has-error': passwordError?.getValidationError('password')
					}">
          <!-- Input -->
          <input
            [type]="'password'"
            class="form-field"
            id="password"
            [(ngModel)]="passwordInput"
            (ngModelChange)="passwordError = null"
            (keydown.enter)="onClickConfirm()"
            tabindex="2"
            name="password"
            autofocus
            placeholder="{{ 'password_validation_enter_password' | translate }}"
            required />
          <!-- Errors -->
          @if (passwordError?.getValidationError('password')) {
            <div class="form-error has-error align-left">
              {{ passwordError?.getValidationError("password") }}
            </div>
          }
        </form>
        <!-- Forgot password -->
        <a [href]="forgotPasswordLink" target="_blank">{{ "password_validation_lost_password" | translate }}</a>
      </div>
    </div>
    <!-- Action button -->
    <div class="text-center">
      <loading-button
        styles="btn btn-primary btn-summary btn-lg mod-send"
        (onClick)="onClickConfirm()"
        [disabled]="!passwordInput"
      [text]="'password_validation_action_button'"></loading-button>
    </div>
  </div>
</div>
